'use client';

import { Link } from '@/app_components/common/Link';
import { ButtonV2 } from '../ui/ButtonV2';

export const Unavailable = () => {
  return (
    <div
      className='flex flex-col layout-nav-gap'
      data-cy='ez-newswire-unavailable-page'
      data-gap='false'
    >
      <div className='flex flex-col items-center justify-center h-[450px] max-w-[1280px] m-auto p-4 lg:p-12 gap-8 font-graphik-compact'>
        <div className='text-center text-primary text-xl lg:text-[28px] font-semibold leading-[130%]'>
          Press Releases are temporarily unavailable. Please refresh.
        </div>
        <div className='flex gap-4'>
          <ButtonV2
            as='button'
            className='py-4 px-8'
            data-cy='ez-newswire-unavailable-page-refresh-button'
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </ButtonV2>
          <Link
            className='w-fit py-4 px-8 rounded-full button-primary button-primary-hover button-text-primary text-base font-medium leading-4'
            data-cy='ez-newswire-unavailable-page-home-button'
            href='/'
          >
            Homepage
          </Link>
        </div>
      </div>
    </div>
  );
};

// biome-ignore lint/style/useNamingConvention: component name matches route convention
export function LoadingFallback() {
  return (
    <div
      className='h-screen flex items-center justify-center'
      data-gap='false'
    >
      <div className='animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600' />
    </div>
  );
}
